import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import { components } from 'react-select';
import AsyncSelect from 'react-select/async';
import PropTypes from 'prop-types';
import { customStyles, DropdownIndicator, LoadingIndicator } from './Common';

class AsyncSimpleSelect extends Component {
  state = {
    inputCharsLength: 0,
    options: [],
    initialOptions: [],
    selectedValue: null,
  };

  componentDidMount() {
    const { defaultValue } = this.props;
    if (defaultValue) {
      this.setState({ selectedValue: this.setValue(defaultValue) });
    }
  }

  option = (option) => {
    return components.Option && <components.Option {...option}>{this.text(option)}</components.Option>;
  };

  getOptions = async (inputValue, valueFromProp) => {
    const { minCharactersToRender, t } = this.props;
    const { options } = this.state;
    let isId = false;
    if (valueFromProp && valueFromProp !== '' && options.length === 0 && inputValue === '') {
      isId = true;
      const disabledOptions = [];
      disabledOptions.push({ label: t('labelStartTyping'), value: 0, isDisabled: 'yes' });
      const optionsFromCall = await this.getFromAsyncService(valueFromProp, isId);
      this.setState({ initialOptions: optionsFromCall });
      return disabledOptions.concat(optionsFromCall);
    }

    if (!((minCharactersToRender && minCharactersToRender <= inputValue.length) || !minCharactersToRender)) {
      this.setState({ options: [] });
      return [];
    }

    return this.getFromAsyncService(inputValue, isId);
  };

  getFromAsyncService = async (inputValue, isId) => {
    const { asyncService, valueParameter, labelParameter, labelBracketParameter, extraParameter, params = { all: true } } = this.props;

    const response = await asyncService(inputValue, isId, params);
    if (valueParameter && labelParameter) {
      if (labelBracketParameter) {
        const options = response.map((m) => ({
          value: m[valueParameter],
          label: `${m[labelParameter]} (${m[labelBracketParameter]})`,
          ...(extraParameter && { extra: m[extraParameter] }),
        }));
        this.setState({ options });
        return options;
      }
      const options = response.map((m) => ({
        value: m[valueParameter],
        label: m[labelParameter],
        ...(extraParameter && { extra: m[extraParameter] }),
      }));
      this.setState({ options });
      return options;
    }
    return [];
  };

  text = (item, innerProps) => {
    const { addon } = this.props;
    return (
      <div className="options-check w-100" {...innerProps}>
        <span className="custom-label">{item.label}</span>
        {addon && addon(item)}
      </div>
    );
  };

  valueContainer = ({ children, ...props }) => {
    const { addon } = this.props;
    const { getValue, hasValue } = props;

    return (
      <components.ValueContainer {...props}>
        {children}
        {addon && hasValue && addon(getValue()[0])}
      </components.ValueContainer>
    );
  };

  handleChange = (value) => {
    const { handleChange, returnFullValue } = this.props;

    this.setState({ selectedValue: value });
    let valueSelect = '';
    if (returnFullValue) {
      valueSelect = value || '';
    } else {
      valueSelect = value ? value.value : '';
    }

    if (handleChange) handleChange(valueSelect);
  };

  onInputChange = (value) => {
    const inputCharsLength = value.length;
    this.setState({ inputCharsLength });
  };

  noOptionsMessage = () => {
    const { t = this.translate, minCharactersToRender } = this.props;
    const { inputCharsLength } = this.state;
    if ((minCharactersToRender && minCharactersToRender <= inputCharsLength) || !minCharactersToRender) {
      return t('noOptionsMessage');
    }
    return t('labelStartTyping');
  };

  setValue = (value) => {
    const { options, initialOptions } = this.state;

    let returnValue = options.find((x) => x.value === value);
    if (!returnValue) {
      returnValue = initialOptions.find((x) => x.value === value);
    }
    return returnValue || '';
  };

  render() {
    const { name, placeholder, customDropdownIcon, className, isDisabled, maxMenuHeight, handleBlur, defaultValue } = this.props;
    const { selectedValue } = this.state;

    const valueToShow = selectedValue || this.setValue(defaultValue);

    return (
      <AsyncSelect
        instanceId={name}
        inputId={`${name}-async-simple-select`}
        components={{
          ...(customDropdownIcon && { DropdownIndicator }),
          Option: this.option,
          LoadingIndicator,
        }}
        loadOptions={(value) => this.getOptions(value, defaultValue)}
        defaultOptions
        onInputChange={this.onInputChange}
        isClearable
        name={name}
        styles={customStyles}
        placeholder={placeholder}
        noOptionsMessage={this.noOptionsMessage}
        maxMenuHeight={maxMenuHeight}
        onChange={this.handleChange}
        onBlur={handleBlur}
        autoBlur
        value={valueToShow}
        className={className}
        isDisabled={isDisabled}
      />
    );
  }
}

AsyncSimpleSelect.defaultProps = {
  customDropdownIcon: true,
  isDisabled: false,
  maxMenuHeight: 240,
  returnFullValue: false,
};

AsyncSimpleSelect.propTypes = {
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  customDropdownIcon: PropTypes.bool,
  minCharactersToRender: PropTypes.number,
  isDisabled: PropTypes.bool,
  onKeyDown: PropTypes.func,
  maxMenuHeight: PropTypes.number,
  returnFullValue: PropTypes.bool,
  extraParameter: PropTypes.string,
};

export default withNamespaces()(AsyncSimpleSelect);
